import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Routes } from '../../constants/RouteConstants';
import mainLogo from '../../Assets/images/main-logo.svg';
import mainLogoShort from '../../Assets/images/cms-logo.png';
import { LanguageConstants } from '../../constants/LanguageConstants';

type NavKey = 'what' | 'about' | 'trust';

type LandingMarketingNavProps = {
  activeNav?: NavKey | null;
};

export default function LandingMarketingNav({ activeNav = null }: LandingMarketingNavProps) {
  const [navScrolled, setNavScrolled] = useState(false);

  const navSections: { key: NavKey; label: string; to: string | { pathname: string; hash: string } }[] = [
    {
      key: 'what',
      label: LanguageConstants?.LANDING_NAV_WHAT,
      to: { pathname: '/', hash: 'landing-what-we-do' },
    },
    {
      key: 'about',
      label: LanguageConstants?.LANDING_NAV_ABOUT,
      to: '/cms/about-us',
    },
    {
      key: 'trust',
      label: LanguageConstants?.LANDING_NAV_TRUST,
      to: { pathname: '/', hash: 'landing-trust' },
    },
  ];

  useEffect(() => {
    const onScroll = () => setNavScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`landing-nav${navScrolled ? ' landing-nav--scrolled' : ''}`}>
      <nav className="navbar navbar-expand-lg navbar-light fixed-top">
        <div className="container landing-nav__inner">
          <Link className="landing-nav__logo navbar-brand" to="/">
            <img src={mainLogo} alt="" className="logo-large" width={160} height={40} />
            <img
              src={mainLogoShort}
              alt=""
              className="landing-nav__logo-img logo-short"
              width={160}
              height={40}
            />
          </Link>

          <div className="landing-nav__actions pb-2 pb-lg-0 pt-3 pt-lg-0 d-lg-none">
            <Link to={Routes.Login} className="landing-nav__login">
              {LanguageConstants?.LOGIN}
            </Link>
            <Link to={Routes.Signup} className="landing-nav__signup">
              {LanguageConstants?.SINGUP}
            </Link>
          </div>

          <button
            className="navbar-toggler landing-nav__mobile-toggle"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#landingMarketingNavbar"
            aria-controls="landingMarketingNavbar"
            aria-expanded="false"
            aria-label={LanguageConstants?.LANDING_ARIA_MENU}
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="landingMarketingNavbar">
            <ul
              className="navbar-nav landing-nav__links mx-auto pt-3 pt-lg-0"
              aria-label={LanguageConstants?.LANDING_NAV_PRIMARY}
            >
              {navSections.map((item) => (
                <li className="nav-item" key={item.key}>
                  <Link
                    to={item.to}
                    className={`landing-nav__link nav-link${
                      activeNav === item.key ? ' landing-nav__link--active active' : ''
                    }`}
                    data-bs-toggle="collapse"
                    data-bs-target="#landingMarketingNavbar"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="landing-nav__actions pb-2 pb-lg-0 pt-3 pt-lg-0 d-none d-lg-flex">
            <Link to={Routes.Login} className="landing-nav__login">
              {LanguageConstants?.LOGIN}
            </Link>
            <Link to={Routes.Signup} className="landing-nav__signup">
              {LanguageConstants?.SINGUP}
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}
